export const FISHING_TODAY_LOCATION_SOURCE = Object.freeze({
  PROFILE: "profile_city",
  LIVE: "live_gps",
  FAVORITE_SPOT: "favorite_spot",
});

export const createProfileFishingLocation = () => ({
  source: FISHING_TODAY_LOCATION_SOURCE.PROFILE,
});

export const createLiveFishingLocation = (position) => {
  const latitude = position?.coords?.latitude;
  const longitude = position?.coords?.longitude;

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    throw new TypeError("A valid device position is required.");
  }

  return {
    source: FISHING_TODAY_LOCATION_SOURCE.LIVE,
    latitude,
    longitude,
    accuracy: Number.isFinite(position.coords.accuracy)
      ? position.coords.accuracy
      : null,
    acquiredAt: Number.isFinite(position.timestamp)
      ? position.timestamp
      : Date.now(),
  };
};

export const createFavoriteSpotFishingLocation = (context) => {
  const latitude = context?.latitude;
  const longitude = context?.longitude;
  const identityKey = context?.spotKey;

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude < -90 ||
    latitude > 90 ||
    longitude < -180 ||
    longitude > 180 ||
    typeof identityKey !== "string" ||
    !identityKey
  ) {
    throw new TypeError("A valid explicit Favorite Spot context is required.");
  }

  return {
    source: FISHING_TODAY_LOCATION_SOURCE.FAVORITE_SPOT,
    latitude,
    longitude,
    identityKey,
  };
};

export const isLiveFishingLocation = (location) =>
  location?.source === FISHING_TODAY_LOCATION_SOURCE.LIVE &&
  Number.isFinite(location.latitude) &&
  Number.isFinite(location.longitude) &&
  location.latitude >= -90 &&
  location.latitude <= 90 &&
  location.longitude >= -180 &&
  location.longitude <= 180;

export const isCoordinateFishingLocation = (location) =>
  (location?.source === FISHING_TODAY_LOCATION_SOURCE.LIVE ||
    location?.source === FISHING_TODAY_LOCATION_SOURCE.FAVORITE_SPOT) &&
  Number.isFinite(location.latitude) &&
  Number.isFinite(location.longitude) &&
  location.latitude >= -90 &&
  location.latitude <= 90 &&
  location.longitude >= -180 &&
  location.longitude <= 180;

// Five decimal places is precise enough for the forecast request without
// sending excess coordinate precision over the wire.
export const roundFishingCoordinate = (value) =>
  Math.round(Number(value) * 100000) / 100000;
